import { CustomTag } from 'microshop-api';

type TagsProps = {
    tags?: CustomTag[];
    className?: string;
    compact?: boolean;
    children?: (tag: CustomTag, index: number) => JSX.Element;
};

const Tags: React.FC<TagsProps> = ({ tags, className, compact, children }) => {
    return null;
};

export default Tags;
